import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LandingPageStages } from 'src/app/models/enums/landing-page-stages.enum';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, OnDestroy {

    destroy$ = new Subject<void>();

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        history.pushState(null, '', location.origin);
        fromEvent(window, 'popstate')
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                history.pushState(null, '', location.origin);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
    }

    redirectToSignup() {
        this.router.navigate(['/signup']);
    }

    redirectToLoginPage(): void {
        this.router.navigate(['/login']);
    }

}
